import { render } from "./MembersCard.vue?vue&type=template&id=15763b50&scoped=true"
import script from "./MembersCard.vue?vue&type=script&lang=js"
export * from "./MembersCard.vue?vue&type=script&lang=js"

import "./MembersCard.vue?vue&type=style&index=0&id=15763b50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15763b50"]])

export default __exports__